/**
 * Store for user filter profiles.
 */
import filterProfileHelper from '@/helperScripts/fhirHelpers/userFiterProfiles/filterProfileHelper';
import { SearchQueryParentExtension } from '@/tsClasses/fhir/SearchQueryStore';
import { defineStore } from 'pinia';

export const usefilterProfileStore = defineStore('filterProfileStore', {
  state: () => {
    return {
      filterProfiles: [] as Array<SearchQueryParentExtension>, //FHIR object containing filter profiles
    };
  },
  getters: {},
  actions: {
    async initialize() {
      await this.updateSearchQueryStore();
    },

    async updateSearchQueryStore() {
      this.filterProfiles =
        await filterProfileHelper.getFilterProfilesForCurrentUser();
    },
  },
});
